import { SITE_URL, SITE_NAME } from './seoConfig';

export const GOOGLE_META_TAGS = [
  { name: 'geo.region', content: 'TH' },
  { name: 'geo.placename', content: 'Thailand' },
  { name: 'language', content: 'Thai' },
  { name: 'content-language', content: 'th' },
  { name: 'distribution', content: 'global' },
  { name: 'rating', content: 'general' },
];

export const GOOGLE_ROBOTS_CONTENT =
  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';

export function buildGoogleLinkTags() {
  return [
    { rel: 'canonical', href: SITE_URL },
    { rel: 'alternate', hrefLang: 'th-th', href: SITE_URL },
    { rel: 'alternate', hrefLang: 'x-default', href: SITE_URL },
  ];
}

export function buildPublisherMeta() {
  return [
    { property: 'og:site_name', content: SITE_NAME },
    { property: 'og:locale', content: 'th_TH' },
    { property: 'og:locale:alternate', content: 'th_TH' },
    { name: 'twitter:site', content: '@TanateSukonrat2' },
  ];
}
